import {AppState} from "../../Redux/Types";
import {connect} from "react-redux";
import {UserNavbar} from "../Presentation/UserNavbar/UserNavbar";
import {bindActionCreators} from "redux";
import {closeUserMenu, openUserMenu} from "../../Redux/Actions";

function mapStateToProps(state: AppState) {
    return {
        profileReady: state.profileReady,
        user: state.user,
        isMenuOpen: state.menus.user,
    }
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        openUserMenu,
        closeUserMenu,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserNavbar);